<template>
  <div>
    <h1 class="ts-uppercase">
      {{
        $t('visitation.totalLength') +
          ': ' +
          (record != undefined ? record.total_distance : 0)
      }}
    </h1>
    <gmap-map :center="center" :zoom="13" style="width:100%;  height: 100vh;">
      <gmap-polyline
        :path="polyLin"
        :options="{ geodesic: true, strokeColor: '#FF0000' }"
      >
      </gmap-polyline>
      <gmap-marker
        v-for="(marker, index) in allMarker"
        :key="index"
        :position="marker"
      >
        <!-- :icon="{
          url: marker_icon
        }" -->
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'viewMap',
  props: ['record'],
  data() {
    return {
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      // marker_icon: require('@/assets/marker.png')
    }
  },
  created() {
    if (this.record) {
      var locat = this.record.json_visitation_detail
      this.center = { lng: locat[0].dealer_long, lat: locat[0].dealer_lat }
    }
  },
  computed: {
    polyLin() {
      if (this.record) {
        return this.record.json_visitation_detail
          .filter(d => d.check_in_time != null)
          .map(el => ({
            lat: el.dealer_lat,
            lng: el.dealer_long
          }))
      }
      return []
    },
    allMarker() {
      if (this.record) {
        return this.record.json_visitation_detail.map(el => ({
          lat: el.dealer_lat,
          lng: el.dealer_long
        }))
      }
      return []
    }
  }
}
</script>
